'use client';
import React, { Component } from 'react';

import Task from '../reusable-components/layouts-components__krdv/task';
import Complex from '../reusable-components/layouts-components__krdv/complex';
import Process from '../reusable-components/layouts-components__krdv/process';
import Services from '../reusable-components/layouts-components__krdv/services';
import Results from '../reusable-components/layouts-components__krdv/results';
import Numbers from '../reusable-components/layouts-components__krdv/numbers';
import Team from '../reusable-components/layouts-components__krdv/team';

import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';

import OfferButton from '../../../../../shared/sections/OfferButton';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import CommonSmallTitle from '../common-components/common-small-title';
import CommonSmallText from '../common-components/common-small-text';

const rkvdMainTitle = {
    titleMainText: `Серия сервисов для&nbsp;личного кабинета сайта Корпорации развития Дальнего Востока`,
    titleAnimation: '/images/pic/preview/krdv.png',
    subtitleContainer: [
        {
            modeText: 'клиент',
            colorMode: '#90134e',
            nameText: 'Корпорация развития Дальнего Востока',
        },
        {
            modeText: 'Отрасль',
            colorMode: '#90134e',
            nameText: 'Государственный сектор',
        },
        {
            modeText: 'Дизайн, разработка',
            colorMode: '#90134e',
            nameText: 'PHP, Bitrix, React, Sass, БЭМ, Webpack, MySQL',
        },
        {
            modeText: 'Технологии',
            colorMode: '#90134e',
            nameText: 'PHP, Laravel, Bitrix, Docker, React, Mobx, Webpack',
        },
    ],
};

const nextProjectKrvd = {
    nextProjectTitle: 'ИТ-система главного технологического акселератора страны GenerationS',
    nextProjectImg: '/images/pic/preview/generation.png',
    nextProjectLink: '/cases/development/gens',
    nextProjectLinkTitle: 'GenerationS',
    nextProjectText:
        'Создали площадку для проведения отбора в корпоративные акселераторы крупнейших мировых компаний',
};

class Krdv extends Component {
    render() {
        return (
            <section className="krdv">
                <MainTitle MainTitle={rkvdMainTitle}>
                    <CommonSmallTitle>Корпорация развития Дальнего Востока</CommonSmallTitle>
                    <CommonSmallText>
                        Это компания, осуществляющая функции по&nbsp;управлению территориями
                        опережающего социально-экономического развития и&nbsp;свободного порта
                        Владивосток в&nbsp;субъектах Российской Федерации, входящих в&nbsp;состав
                        Дальневосточного&nbsp;ФО.
                    </CommonSmallText>
                </MainTitle>

                <Task />

                <Complex />

                <Process />

                <Services />

                <Results />

                <Numbers />

                <Team />

                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>

                <NextProject NextProject={nextProjectKrvd} />
            </section>
        );
    }
}

export default Krdv;
